/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import React from "react";
import { Close } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Box, IconButton, Snackbar } from "@mui/material";

import { SNACKBAR_ALERT_DEFAULT_PROPS } from "../constants";
import { selectSnackBarMessage } from "../../store/snackBar/snackBarSelector";
import { setSnackBarDisplay } from "../../store/snackBar/snackBarActionCreator";

export interface ISnackbarAlert {
  show: boolean;
  autoHideDuration?: number;
  message: string;
  severity: "success" | "info" | "warning" | "error";
}
const SnackbarAlert: React.FunctionComponent<ISnackbarAlert> = (
  props: ISnackbarAlert
) => {
  const dispatch = useDispatch();
  const snackBarMessage = useSelector(selectSnackBarMessage);
  const { autoHideDuration, message, severity } = props;

  const handleClose = (event?: any, reason?: string) => {
    if (event !== null && reason === "clickaway") {
      return;
    }
    dispatch(
      setSnackBarDisplay({
        ...SNACKBAR_ALERT_DEFAULT_PROPS,
        show: false,
      })
    );
  };
  const action = (
    <IconButton color="inherit" aria-label="Close Icon Button" onClick={handleClose}>
      <Close fontSize="small" />
    </IconButton>
  );
  const alertProps = severity === "error" ? { action: action } : {};
  const snackBarExtraProps = severity !== "error" ? { autoHideDuration: autoHideDuration } : {};
  return (
    <Box>
      <Snackbar
        onClose={handleClose}
        {...snackBarExtraProps}
        style={{ marginLeft: 50 }}
        open={snackBarMessage.show}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        ClickAwayListenerProps={{
          mouseEvent: "onClick",
          onClickAway: handleClose,
        }}
      >
        <Alert
          id="alert-message"
          elevation={2}
          variant="filled"
          severity={severity}
          {...alertProps}
        >
          {message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default SnackbarAlert;
